<!-- <div class="table-header" style="margin-bottom: 8px">
  <button
    nz-button
    nzType="primary"
    nzSize="small"
    (click)="showSettingsModal()"
  >
    <span nz-icon nzType="setting" nzTheme="outline"></span>
  </button>
</div> -->

@if (quickSearch) {
  <div class="quick-search">
    <nz-input-group [nzPrefix]="quickSearchPrefix" [nzSuffix]="quickSearchSuffix" nzSize="small">
      <input
        type="text"
        nz-input
        [placeholder]="quickSearchPlaceholder"
        [ngModel]="quickSearchValue"
        (ngModelChange)="onQuickSearchInput($event)"
      />
    </nz-input-group>
    <ng-template #quickSearchPrefix>
      <span nz-icon nzType="search" class="quick-search-icon"></span>
    </ng-template>
    <ng-template #quickSearchSuffix>
      @if (quickSearchValue) {
        <span
          nz-icon
          nzType="close-circle"
          nzTheme="fill"
          class="quick-search-clear"
          (click)="clearQuickSearch()"
        ></span>
      }
    </ng-template>
  </div>
}

<nz-table
  [nzData]="searchMode === 'frontend' ? filteredData : data"
  [nzTotal]="searchMode === 'frontend' ? frontendTotal : total"
  [nzLoading]="loading"
  [nzShowTotal]="rangeTemplate"
  [nzShowPagination]="pagination"
  [nzPageSize]="pageSize"
  [nzPageIndex]="currentPage"
  [nzFrontPagination]="searchMode === 'frontend'"
  [nzPageSizeOptions]="pageSizeOptions"
  [nzShowSizeChanger]="true"
  (nzPageIndexChange)="onPageChange($event)"
  (nzPageSizeChange)="onPageSizeChange($event)"
  [nzSize]="'small'"
  [nzScroll]="nzScroll"
  [nzBordered]="bordered"
>
  <thead>
    <!-- <tr>
      @for (column of returnFilteredColumns(); track column.key) {
        <ng-container>
          <th #headerRef>{{ column.title }}</th>
        </ng-container>
      }
    </tr> -->
    <tr>
      @for (column of visibleColumns; track column.key) {
        @if (column.width) {
          <th
            #headerRef
            nz-resizable
            nzPreview
            nzBounds="window"
            [nzShowSort]="!!column.sortFn"
            [nzSortOrder]="column.sortOrder ?? null"
            [nzFilters]="column.filters ?? []"
            (nzSortChange)="onSortChange($event, column.key)"
            (nzFilterChange)="onFilterChange($event, column.key)"
            (nzResizeEnd)="onResize($event, column.key)"
            [nzWidth]="column.width"
            [nzMaxWidth]="256"
            [nzMinWidth]="60"
          >
            {{ column.title }}
            @if (column.searchable) {
              <nz-filter-trigger
                [(nzVisible)]="searchVisible[column.key]"
                [nzDropdownMenu]="menuMap[column.key]"
                (nzVisibleChange)="onSearchVisibleChange(column.key, $event)"
              >
                <span nz-icon nzType="search"></span>
              </nz-filter-trigger>
            }
            @if (column.distinctable) {
              <span
                nz-icon
                [nzType]="
                  activeDistinctColumnKey === column.key ? 'funnel-plot-filled' : 'funnel-plot'
                "
                (click)="toggleDistinct(column.key); $event.stopPropagation()"
                style="margin-left: 8px; cursor: pointer"
              ></span>
            }
            <nz-resize-handle nzDirection="right">
              <div class="resize-trigger"></div>
            </nz-resize-handle>
          </th>
        } @else {
          <th
            #headerRef
            nz-resizable
            nzPreview
            nzCustomFilter
            nzBounds="window"
            [nzShowSort]="!!column.sortFn"
            [nzSortOrder]="column.sortOrder ?? null"
            [nzFilters]="column.filters ?? []"
            (nzSortOrderChange)="onSortChange($event, column.key)"
            (nzFilterChange)="onFilterChange($event, column.key)"
          >
            {{ column.title }}
            @if (column.searchable && viewInited == true) {
              <nz-filter-trigger
                [(nzVisible)]="searchVisible[column.key]"
                [nzDropdownMenu]="menuMap[column.key]"
                (nzVisibleChange)="onSearchVisibleChange(column.key, $event)"
              >
                <span span nz-icon nzType="search"></span>
              </nz-filter-trigger>
            }
            @if (column.distinctable) {
              <span
                nz-icon
                [nzTheme]="activeDistinctColumnKey === column.key ? 'fill' : 'outline'"
                nzType="funnel-plot"
                (click)="toggleDistinct(column.key); $event.stopPropagation()"
                style="margin-left: 8px; cursor: pointer"
              ></span>
            }
          </th>
        }
      }
      @if (actions && actions.length !== 0) {
        <th>Actions</th>
      }
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let row of searchMode === 'frontend' ? filteredData : data; trackBy: trackRow"
      (click)="onRowClick(row)"
      style="cursor: pointer"
      #tdRef
    >
      <td *ngFor="let column of visibleColumns; trackBy: trackColumn">
        <ng-container *ngIf="column.key === 'status'; else defaultCell">
          <span [style.color]="row[column.key]?.color">
            <i
              nz-icon
              [nzType]="row[column.key]?.icon"
              [nzSpin]="row[column.key]?.spin || null"
            ></i>
            {{ row[column.key]?.text }}
          </span>
        </ng-container>
        <ng-template #defaultCell>
          {{ row[column.key] }}
        </ng-template>
      </td>
      @if (actions && actions.length != 0) {
        <td>
          <div class="action-buttons">
            <app-view-button
              *ngFor="let action of actions"
              [text]="action.label"
              [type]="action.type ?? 'primary'"
              [icon]="action.icon ?? null"
              [size]="'small'"
              [danger]="action.danger ?? false"
              (buttonClick)="onActionClick(action.key, row)"
            ></app-view-button>
          </div>
        </td>
      }
    </tr>
  </tbody>
</nz-table>
@for (column of columns; track column.key) {
  @if (column.searchable) {
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <input
            type="text"
            nz-input
            placeholder="Search {{ column.title }}"
            [(ngModel)]="searchValues[column.key]"
          />
          <div class="button-group">
            <button nz-button nzSize="small" (click)="resetSearch(column.key)">Reset</button>
            <button nz-button nzSize="small" nzType="primary" (click)="applySearch(column.key)">
              Search
            </button>
          </div>
        </div>
      </div>
    </nz-dropdown-menu>
  }
}

<nz-modal
  [(nzVisible)]="isSettingsModalVisible"
  nzTitle="Customize Columns"
  (nzOnCancel)="handleSettingsCancel()"
  (nzOnOk)="handleSettingsOk()"
>
  <ng-container *nzModalContent>
    <div nz-row [nzGutter]="24">
      <!-- Visible Columns List -->
      <div nz-col [nzSpan]="12">
        <p>Visible Columns (drag to reorder)</p>
        <div
          cdkDropList
          #visibleList="cdkDropList"
          id="visibleList"
          [cdkDropListData]="visibleColumns"
          [cdkDropListConnectedTo]="[hiddenList]"
          class="column-list"
          (cdkDropListDropped)="drop($event)"
        >
          <div class="column-item" *ngFor="let col of visibleColumns; let i = index" cdkDrag>
            {{ col.title }}
            <span
              nz-icon
              nzType="minus-circle"
              nzTheme="outline"
              (click)="hideColumn(col, i)"
              style="cursor: pointer; margin-left: 8px"
            ></span>
          </div>
        </div>
      </div>
      <!-- Hidden Columns List -->
      <div nz-col [nzSpan]="12">
        <p>Hidden Columns</p>
        <div
          cdkDropList
          #hiddenList="cdkDropList"
          id="hiddenList"
          [cdkDropListData]="hiddenColumns"
          [cdkDropListConnectedTo]="[visibleList]"
          class="column-list"
          (cdkDropListDropped)="drop($event)"
        >
          <div class="column-item" *ngFor="let col of hiddenColumns; let i = index" cdkDrag>
            {{ col.title }}
            <span
              nz-icon
              nzType="plus-circle"
              nzTheme="outline"
              (click)="showColumn(col, i)"
              style="cursor: pointer; margin-left: 8px"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>
<ng-template #rangeTemplate let-range="range" let-total>
  {{ range[0] }}-{{ range[1] }} of {{ total }} items
</ng-template>
